import { ReplaySubject } from 'rxjs'

import { AssociatedMedias } from './associated-medias'
import { DataSynchronisationStatus } from './data-synchronisation-status';

export interface DataSynchroEvent {
    status: DataSynchronisationStatus,
    name: string
}

export interface CachedEntityData<T> {
    id: string;
    body: T;
}

export type SynchroMediaUpdates<T> = CachedEntityData<T> & { 
    mediaSubjects: { [replayName: string]: ReplaySubject<ReplaySubjectContent> },
    cachedMedias: AssociatedMedias
}
export const MEDIA_SUBJECTS_KEYS = {
    image: 'media',
    pdf: 'pdf'
}
export interface ReplaySubjectContent {
    fileName?: string,
    newMediaId?: string,
    cacheKeys?: string[],
    blob?: Blob,
    error?: any
}

export interface PushCachedValueResult {
    success: boolean,
    newId?: string
}

export interface PushResult {
    nbToPush: number;
    nbPushSuccesses: number;
}

export interface DataStoreOptions {
    endpoint?: string;
    query?: Record<string, any>;
    emulateSearch?: boolean;
}